// extracted by mini-css-extract-plugin
module.exports = {"wondeBanner":"CheckWondeStatus_wondeBanner__2BVdy"};